<div class="cx-order-summary">
  <div class="container">
    @if (order?.replenishmentOrderCode) {
      <div class="cx-summary-card">
        <cx-card [content]="getReplenishmentCodeCardContent(order?.replenishmentOrderCode) | async"></cx-card>
        @if (order?.created) {
          <cx-card [content]="getOrderCurrentDateCardContent(order?.created | cxDate) | async"></cx-card>
        }
        <cx-card [content]="getReplenishmentActiveCardContent(order?.active) | async"></cx-card>
      </div>
      <div class="cx-summary-card">
        <cx-card [content]="getReplenishmentStartOnCardContent(order?.firstDate) | async"></cx-card>
        <cx-card [content]="getReplenishmentFrequencyCardContent(order?.trigger?.displayTimeTable) | async"></cx-card>
        <cx-card [content]="getReplenishmentNextDateCardContent(order?.trigger?.activationTime) | async"></cx-card>
      </div>
    } @else {
      <div class="cx-summary-card">
        <cx-card [content]="getSpecialInstructions(order?.specialInstructions) | async"></cx-card>
        <cx-card [content]="getRequestedDeliveryDate(order?.requestedDeliveryDate) | async"></cx-card>
      </div>
    }


    @if (order?.purchaseOrderNumber || order?.purchaseOrderNumber === '') {
      <div class="cx-summary-card">
        <cx-card [content]="getPurchaseOrderNumber(order?.purchaseOrderNumber) | async"></cx-card>
        <cx-card [content]="getMethodOfPaymentCardContent(order.paymentInfo) | async"></cx-card>
      </div>
    }

    <div class="cx-summary-card">
      @if (order?.deliveryAddress) {
        <cx-card [content]="removeNameFromCard(getAddressCardContent(order?.deliveryAddress) | async)"></cx-card>
      }
    </div>

    @if (order?.paymentInfo) {
      <div class="cx-summary-card">
        <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
        <cx-card [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>
      </div>
    }
  </div>
</div>
